// extracted by mini-css-extract-plugin
module.exports = {"image":"LogoLink_image__Gfc1_","footerImage":"LogoLink_footer-image__jjWmp"};